import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=a0691e36"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports